import { bootstrapApplication } from '@angular/platform-browser';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Windows browsers don't render flag emoji (🇺🇿). This injects a Twemoji flag
// webfont (only on browsers lacking support) named "Twemoji Country Flags",
// which is prepended to the global font stack in styles.css.
polyfillCountryFlagEmojis();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
